<div>
  <button
    *ngIf="community.name !== 'uMuzi'"
    type="button"
    class="btn btn-primary"
    (click)="membershipListModal.show()"
  >
    <div class="row show-member-icon">
      <div style="margin: auto">
        <i class="icofont icofont-people"></i>
        <span> {{ community.memberCount }} members </span>
      </div>
    </div>
    <!-- Content marker -->
    <ng-content></ng-content>
  </button>

  <!-- Community-members-modal -->
  <membership-list-modal
    #membershipListModal
    [community]="community"
    [limit]="limit"
    [config]="config"
    [hideFooter]="true"
  >
  </membership-list-modal>
  <!-- Community-members-modal -->
</div>
